import { useHospitalDetailContext } from '../hospital-detail-context'

import HospitalDetailBottomBarSection from '@/features/hospital/components/hospital-detail-page/components/hospital-detail-bottom-bar-section'

export const HospitalDetailCTAButtons = () => {
  const { user, hospital, analytics } = useHospitalDetailContext()

  return (
    <HospitalDetailBottomBarSection
      hospital={hospital}
      user={user}
      onClickConsultation={analytics.trackConsultationClick}
      onClickChatConsultation={analytics.trackChatConsultationClick}
    />
  )
}
